var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewEmptyPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 24.0833V26.9167H12.75V24.0833H4.25ZM4.25 7.08333V9.91667H18.4167V7.08333H4.25ZM18.4167 29.75V26.9167H29.75V24.0833H18.4167V21.25H15.5833V29.75H18.4167ZM9.91667 12.75V15.5833H4.25V18.4167H9.91667V21.25H12.75V12.75H9.91667ZM29.75 18.4167V15.5833H15.5833V18.4167H29.75ZM21.25 12.75H24.0833V9.91667H29.75V7.08333H24.0833V4.25H21.25V12.75Z",
    fill: "#00456F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyPreferences);
export default __webpack_public_path__ + "static/media/new_empty_preferences.0cccf972c62641f533978fa14946fc43.svg";
export { ForwardRef as ReactComponent };